'use strict';

var _ = require('lodash');
var d3 = require('d3');
var angular = require('angular');
var AbstractChart = function AbstractChart($window, d3Helper) {
  /**
   * Create a 'backbone' of the chart. Main group contains preDataGroup, dataGroup, postDataGroup.
   * Only dataGroup should have the data attached to DOM nodes.
   * preDataGroup, postDataGroup should be data-free.
   * @param container
   * @constructor
   */
  function AbstractChart(container) {
    this.svg = d3.select(container[0]).select('svg.chart,svg.viewport');
    var chartWithViewPort = container.siblings('.viewport-container').length;
    this.container = container;
    this.destroyableElements = [];
    this.mainGroup = d3Helper.createGroupElement(this.svg, 'group-main');
    this.preDataGroup = d3Helper.createGroupElement(this.mainGroup, 'pre-data');
    this.dataGroup = d3Helper.createGroupElement(this.mainGroup, 'group-data');
    this.postDataGroup = d3Helper.createGroupElement(this.mainGroup, 'post-data');
    this.dataPropertyName = '';
    this.resizeHandler = _.throttle(function () {
      var width = this.container.width();
      var height = this.container.height();
      if (width > 0 && height > 0) {
        // skip if width did not change
        if (this.params && this.params.containerWidth === width) {
          return;
        }
        this.render(this.data);
      }
    }.bind(this), 250);

    // the viewport will trigger rendering of the main chart
    if (!chartWithViewPort) {
      $window.addEventListener('resize', this.resizeHandler);
    }
    container.on('$destroy', function () {
      $window.removeEventListener('resize', this.resizeHandler);
      this.destroyElements();
    }.bind(this));
  }

  /**
   * Allows for setting a custom property name, when this.data is a complex object and not an array
   * This is required for iterating over the main data set and build objects like groups, bars etc.
   * @param property
   */
  AbstractChart.prototype.setDataPropertyName = function (property) {
    this.dataPropertyName = property;
  };

  // if resizing, data and xRange will be empty
  AbstractChart.prototype.initChart = function (data, xRange, params) {
    this.data = data || this.data;
    this.visibleXRange = xRange || this.visibleXRange || [0, this.data.length];
    this.params = params(this.container.width(), this.container.height());
    this.translateChart();
  };

  /**
   * Sets the data on the dataGroup node. Calls element functions to render the content.
   * @param elementFunctions
   * @param scales
   */
  AbstractChart.prototype.callForDataGroup = function (elementFunctions, scales) {
    this.destroyableElements = _.concat(this.destroyableElements, elementFunctions);
    scales = scales || this.scales;
    var mainData = this.dataPropertyName ? this.data[this.dataPropertyName] : this.data;
    this.dataGroup.datum(mainData);
    elementFunctions.forEach(function (elementFunction) {
      this.dataGroup.call(elementFunction.params(this.params).scales(scales));
    }, this);
  };
  function callDataGroup(context, elementFunctions, scales, dataGroup) {
    context.destroyableElements = _.concat(context.destroyableElements, elementFunctions);
    scales = scales || context.scales;
    elementFunctions.forEach(function (elementFunction) {
      dataGroup.call(elementFunction.scales(scales));
    }, context);
    return scales;
  }

  /**
   * Calls element function to render the content on preDataGroup node
   * @param elementFunctions
   * @param scales
   */
  AbstractChart.prototype.callForPreDataGroup = function (elementFunctions, scales) {
    callDataGroup(this, elementFunctions, scales, this.preDataGroup);
  };

  /**
   * Calls element function to render the content on postDataGroup node
   * @param elementFunctions
   * @param scales
   */
  AbstractChart.prototype.callForPostDataGroup = function (elementFunctions, scales) {
    callDataGroup(this, elementFunctions, scales, this.postDataGroup);
  };
  AbstractChart.prototype.translateChart = function () {
    var padding = this.params.padding;
    var translation = [padding.left, padding.top];
    this.mainGroup.attr('transform', 'translate(' + translation + ')');
    if (this.params.forceWidth) {
      var svgWidth = padding.left + padding.right + this.params.width;
      this.svg.attr({
        width: svgWidth + 'px'
      });
    }
    if (this.params.forceHeight) {
      var svgHeight = padding.top + padding.bottom + this.params.height;
      this.svg.attr({
        height: svgHeight + 'px'
      });
    }
  };

  // we may want to keep the Y axis outside of the main chart to allow overflow-x work
  AbstractChart.prototype.callForYAxis = function (yAxis, scales, yAxisContainer) {
    yAxisContainer = yAxisContainer || '.chart-y-axis';
    var svg = d3.select(this.container[0]).select(yAxisContainer);
    svg.call(yAxis.params(this.params).scales(scales || this.scales));
    svg.select('.group-axes').attr('transform', 'translate(' + [0, this.params.padding.top] + ')');
  };
  AbstractChart.prototype.brushChangeAction = function (selection, groups) {
    if (selection.length !== 0) {
      var ranges = _.isArray(selection[0]) ? selection : [selection];
      this.dataGroup.call(groups.withRanges(ranges));
    }
  };
  AbstractChart.prototype.destroyElements = function () {
    if (this.destroyableElements) {
      _.forEach(this.destroyableElements, function (element) {
        if (_.isFunction(element.destroy)) {
          element.destroy();
        }
      });
      this.destroyableElements = [];
    }
    if (this.tooltipClassName) {
      angular.element(document.getElementsByClassName('d3-tip ' + self.tooltipClassName)).remove();
    }
  };
  return AbstractChart;
};
AbstractChart.$inject = ['$window', 'd3Helper'];
module.exports = AbstractChart;